import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetUserLogs } from "src/api/settings/users";
import { useEffect, useState } from "react";
import { Stack, TablePagination, Typography } from "@mui/material";
import moment from "moment";

const UserLogs = () => {
  const { id } = useParams();
  const { t } = useTranslation("settings");
  const { t: generalT } = useTranslation("general");

  const [pageNumber, setPageNumber] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);

  const tableHeadText = [
    t("action"),
    generalT("createdAt"),
  ];

  // APIs
  const { data, isLoading } = useGetUserLogs({
    page: pageNumber + 1,
    id: id as string,
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage);
  };

  const emptyDataArr = data?.data?.length === 0;

  useEffect(() => {
    if (data) {
      setTotal(data.meta?.total ?? 0);
    }
  }, [data]);

  return (
    <Stack gap={2} p={{ xs: 2, sm: "8px 32px 32px 32px" }}>
      <Stack
        direction={"row"}
        spacing={"12px"}
        alignItems={"center"}
        color={"#101828"}
      >
        <Typography fontSize={"32px"} lineHeight={"38.4px"}>
          {t("logs")}
        </Typography>
      </Stack>
      <TableContainer component={Paper} variant="outlined">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {tableHeadText.map((item) => (
                <TableCell
                  key={item}
                  align="center"
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "18px",
                    color: "#475467",
                    bgcolor: "#F9FAFB",
                  }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableLoadingSkeleton rowsLength={8} cellsLength={2} />
          ) : (
            <TableBody>
              {data?.data?.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    {row.method} {row.type}
                  </TableCell>
                  <TableCell align="center" dir="ltr">
                    {moment(row?.created_at).format("YYYY-MM-DD HH:mm:ss")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {emptyDataArr && <NoData />}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20]}
        component="div"
        count={total}
        rowsPerPage={20}
        page={pageNumber}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />
    </Stack>
  );
};
export default UserLogs;
